import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { TbWorld } from 'react-icons/tb';

const WHATSAPP_URL = 'https://wa.me/963984976756';
const STORE_URL    = 'https://store.vertex-group.site';

const WelcomePopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show popup every time the page is opened
    const timer = setTimeout(() => setVisible(true), 600);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="wp-overlay" onClick={() => setVisible(false)}>
      <div className="wp-card" onClick={(e) => e.stopPropagation()}>

        {/* Close */}
        <button className="wp-close" onClick={() => setVisible(false)} aria-label="إغلاق">×</button>

        {/* Logo + Header */}
        <div className="wp-header">
          <img src="/logo.png" alt="Vertex Group" className="wp-logo" />
          <h2 className="wp-title">فيرتكس جروب</h2>
          <p className="wp-subtitle">مستودع المعدات الصناعية والخرداوات</p>
        </div>

        {/* Divider */}
        <div className="wp-divider" />

        <p className="wp-cta-text">تواصل معنا أو تصفح متجرنا مباشرةً</p>

        {/* Action Buttons */}
        <div className="wp-actions">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="wp-btn wp-btn-whatsapp"
            onClick={() => setVisible(false)}
          >
            <FaWhatsapp size={26} />
            <span>واتساب</span>
          </a>

          <a
            href={STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="wp-btn wp-btn-store"
            onClick={() => setVisible(false)}
          >
            <TbWorld size={26} />
            <span>المتجر</span>
          </a>
        </div>

        <p className="wp-dismiss" onClick={() => setVisible(false)}>تصفح الصفحة</p>
      </div>
    </div>
  );
};

export default WelcomePopup;
